import useSWRMutation from 'swr/mutation';
import { apiClient } from 'config/api';

/**
 * Sends a POST request to manually update the client's biometric data.
 *
 * @param {string} url - The endpoint URL for the request.
 * @param {{ arg: any }} param1 - An object containing the payload to be sent with the request.
 * @returns {Promise<any>} - The response data from the server.
 */
const manualBiometricUpdateFetcher = async (url, { arg }) => {
  const { data } = await apiClient.post(url, arg);
  return data;
};

/**
 * Custom hook to manually update a client's biometric data.
 *
 * @returns {{
 *   trigger: (arg: any) => Promise<any>,
 *   isLoading: boolean,
 *   data: any,
 *   error: any
 * }} - An object containing:
 *   - `trigger`: function to execute the mutation,
 *   - `isLoading`: boolean indicating the loading state,
 *   - `data`: response data from the server,
 *   - `error`: any error that occurred during the request.
 */
export const useManualBiometricUpdate = () => {
  const { trigger, isMutating, data, error } = useSWRMutation(
    '/v2/client/update-biometric-data',
    manualBiometricUpdateFetcher
  );

  return {
    trigger,
    isLoading: isMutating,
    data,
    error,
  };
};
